import { DataSource, Image, Label, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutEdiProfileRemitQuickInfo extends Layout {
    imageGoToClassic: Image;
    imagePartnerNotes: Label;
    labelPartnerNotes: Label;
    panel1: Panel;
    panel2: Panel;
    panel3: Panel;
    panel4: Panel;
    panel5: Panel;
    sourceEdiremitProfile: DataSource;
    textboxAltPartnerId: Textbox;
    textboxFuncReceiverId: Textbox;
    textboxFuncSenderId: Textbox;
    textboxIntReceiverId: Textbox;
    textboxIntSenderId: Textbox;
    textboxPartnerId: Textbox;
    textboxTemplateId: Textbox;
    textboxVersion: Textbox;
}
